import { DocumentData } from "@king-ict/eupisi-ui/models";

import { ProgramRequestClassEnsamble } from "./ProgramRequestClassEnsamble";
import { TeacherLanguage } from "./TeacherLanguage";

export interface ProgramRequestTeacher {
  id: number;
  programRequestDetailId: number;
  oib: string;
  firstName: string;
  lastName: string;  
  programRequestClassEnsambles: ProgramRequestClassEnsamble[];
  statement?: DocumentData;
  diplomaDocument?: DocumentData;
  additionalDocumentation?: DocumentData;
  languages?: TeacherLanguage[];
  isLanguageMandatory: boolean;
  oibChecked?: boolean;
}

export const createProgramRequestTeacherInitial = (isLanguageMandatory: boolean = false): ProgramRequestTeacher => {  
  return {
    id: 0,
    programRequestDetailId: 0,
    oib: "",
    firstName: "",
    lastName: "",
    programRequestClassEnsambles: [{id: 0, ensamble: ""}],
    statement: undefined,
    diplomaDocument: undefined,
    additionalDocumentation: undefined,
    isLanguageMandatory: isLanguageMandatory,
    languages: isLanguageMandatory ? [] : undefined,
    oibChecked: false
  };
}